import React, { useEffect, useState } from 'react'
import { Box, Text } from "grommet"
import AgDataTable from '../../common/AgDataTable'
import { useTTUSUserSelective } from '../../../utils/user'
import { deepClone } from '../../../utils/clone'

const HealthStatusServiceAlgoServerExec = ({ data }) => {

    const [idFilter, setIdFilter] = useState([])
    const userLookup = useTTUSUserSelective(idFilter)

    const tab_col = [
        {
            field: "job_process_id",
            headerName: "Algo Job ID",
            minWidth: 150,

        },
        {
            field: "user_id",
            headerName: "User ID",
            minWidth: 150,

        },
        {
            field: "alias",
            headerName: "Username",
            minWidth: 150,

        },
        {
            field: "email",
            headerName: "Email",
            minWidth: 150,
        },
        {
            field: "orders",
            headerName: "Working Algos",
            minWidth: 150,

        },
    ]

    const [tab_data, settab_data] = useState([])

    useEffect(() => {
        let temp_ids = []
        settab_data(Object.keys(data).reduce((rowData, rowId) => {
            const row = deepClone(data[rowId])
            const emailId = row.user_id && userLookup[row.user_id] ? userLookup[row.user_id].email : '-'
            const alias = row.user_id && userLookup[row.user_id] ? userLookup[row.user_id].alias : '-'
            temp_ids.push(row.user_id)

            rowData.push({
                'uniqueId': row.user_id,
                'job_process_id': row.job_process_id,
                'user_id': row.user_id,
                'alias': alias,
                'email': emailId,
                'orders': row.orders,
            })

            return rowData
        }, []))
        setIdFilter(temp_ids)

        return () => {
            settab_data([])
        }
    }, [data, userLookup])

    return (
        <Box border="top" margin={{ top: "small", left: "xsmall", right: "xsmall" }} fill="horizontal">
            <Text margin={{ top: "8px", bottom: "8px" }} size="small" color="dark-3" weight="bold"> User Algos</Text>

            <AgDataTable
                tab_col={tab_col}
                tab_data={tab_data}
                tableName="HealthStatusServiceAlgoServerExec3"
                tableHeight={700}
            />

        </Box>
    )
}

export default HealthStatusServiceAlgoServerExec